import { ChevronRight, CloudUpload, Receipt } from "@mui/icons-material";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Collapse,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  styled,
  TextField,
  Typography,
  Zoom,
} from "@mui/material";
import { useFormik } from "formik";
import { useState, useEffect } from "react";
import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { grey } from "@mui/material/colors";
import logo from "../images/logo/kalsoft_logo.png";

function CompanyReg(props) {
  const { stageChanger } = props;

  const { state } = useLocation();
  const navigate = useNavigate();

  
  //states for button
  const [submitLoading, setSubmitLoading] = useState(false);
  const [subscription, setSubscription] = useState(1);
  const handleSave = (values) => {
    const args = {
      url: "",
      method: "POST",
      params: values,
    };
  };

  useEffect(() => {
    let parameters = {
      method: "GET",
      url: "http://127.0.0.1:8000/hrm/plan/",
    };

    const loader = async (parameters) => {
      let results = {};
      let params = parameters.params;

      const response = await fetch(parameters.url, {
        mode: "cors",
        method: parameters.method,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      results.status = response.status;
      const fetcher = response.body.getReader();
      let data = [];
      let receivedLength = 0;
      while (true) {
        const { value, done } = await fetcher.read();

        if (done) {
          break;
        }

        data.push(value);
        receivedLength += value.length;
      }
      let chunksAll = new Uint8Array(receivedLength);
      let position = 0;
      for (let chunk of data) {
        chunksAll.set(chunk, position);
        position += chunk.length;
      }
      let result = new TextDecoder("utf-8").decode(chunksAll);

      let finalData = JSON.parse(result);
      results.data = finalData;
      if (results.status === 200) {
        console.log(results.data);

        setPlans(results.data);
      }
    };
    loader(parameters);
  }, []);

  //change btn name from more to less
  const [disabled, setDisabled] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [plans, setPlans] = useState([]);
  const [paymentError, setPaymentError] = useState(null)


  const myFormik = useFormik({
    initialValues: {
      primaryPhone: "",
    },

    validationSchema: Yup.object({
      primaryPhone: Yup.string()
        .required("Required")
        .min(10, "Invalid phone number")
        .max(13, "Invalid phone number")
        .matches(/^[0+]/, "Invalid phone number"),
    }),

    onSubmit: (values) => {
      setLoading(true)
      let parameters = {
        method: "POST",
        url: "http://127.0.0.1:8000/hrm/company/update",
        params: values,
      };
      const formData = new FormData()
      formData.append('company', state.company_name)
      formData.append('subscription', subscription)
      formData.append('primaryPhone', values.primaryPhone)
      formData.append('profile', image)

      const loader = async (parameters) => {
        let results = {};
        let params = parameters.params;

        const response = await fetch(parameters.url, {
          mode: "cors",
          method: parameters.method,
          body: formData,
        });

        results.status = response.status;
        const fetcher = response.body.getReader();
        let data = [];
        let receivedLength = 0;
        while (true) {
          const { value, done } = await fetcher.read();

          if (done) {
            break;
          }

          data.push(value);
          receivedLength += value.length;
        }
        let chunksAll = new Uint8Array(receivedLength);
        let position = 0;
        for (let chunk of data) {
          chunksAll.set(chunk, position);
          position += chunk.length;
        }
        let result = new TextDecoder("utf-8").decode(chunksAll);

        let finalData = JSON.parse(result);
        results.data = finalData;
        if (results.status === 202) {
          setLoading(false)
          setOpenConfirm(true);
          setDisabled(true);
        } else {
          setLoading(false)
          setError(results.data.message);
        }
      };
      loader(parameters);
    },
  });

  const payForm = useFormik({
    initialValues: {
      code: "",
    },

    validationSchema: Yup.object({
      code: Yup.string()
        .required("Required")
        .min(5, "must be more than 5 characters"),
    }),
    onSubmit: (values) => {
      setSubmitLoading(true)
      let parameters = {
        method: "POST",
        url: "http://127.0.0.1:8000/hrm/subscription/payment",
        params: values,
      };
      const formData = new FormData()
      formData.append('code', values.code)
      const loader = async (parameters) => {
        let results = {};

        const response = await fetch(parameters.url, {
          mode: "cors",
          method: parameters.method,
          body: formData,
        });

        results.status = response.status;
        const fetcher = response.body.getReader();
        let data = [];
        let receivedLength = 0;
        while (true) {
          const { value, done } = await fetcher.read();

          if (done) {
            break;
          }

          data.push(value);
          receivedLength += value.length;
        }
        let chunksAll = new Uint8Array(receivedLength);
        let position = 0;
        for (let chunk of data) {
          chunksAll.set(chunk, position);
          position += chunk.length;
        }
        let result = new TextDecoder("utf-8").decode(chunksAll);

        let finalData = JSON.parse(result);
        results.data = finalData;
        if (results.status === 200) {
          setSubmitLoading(false);
          navigate("/home", {state:{}, replace:true});
        } else {
          setSubmitLoading(false);
          setPaymentError(results.data.message);
        }
      };
      loader(parameters);
      
    },
  });

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const planRates = {
    basic: 2500,
    bronze: 3500,
    platinum: 4500,
  };

  const amount = () => {
    if (plans.length > 0) {
      const selected_plan = plans.filter((plan) => {
        if (plan.id == subscription) {
          return true;
        } else {
          return false;
        }
      });
      return selected_plan[0].amount;
    }
  };

  return (
    <>
      <Zoom in={true} style={{ transitionDelay: "200ms" }}>
        <Stack>
      <Box
        display={"flex"}
        bgcolor={grey[100]}
        height={60}
        borderRadius={1}
        alignItems={"center"}
      >
        <Avatar
          src={logo}
          alt="logo"
          sx={{ height: 64, width: 64, ml: 3 }}
        ></Avatar>
        <Typography variant="h5">KALSOFT SYSTEMS</Typography>
        <Box ml={"auto"} display={"flex"} columnGap={2} mr={2}>
          <Button
            variant="outlined"
            sx={{ borderRadius: 4 }}
            size="small"
            onClick={() => {navigate('/', {replace:true})
              }}
          >
           home
          </Button>
          
        </Box>
      </Box>
        <Card elevation={2}>
          <CardHeader title="Subscriptions" />
          <Divider variant="middle" />
          <CardContent
            sx={{ display: "flex", flexDirection: "row", columnGap: 2 }}
          >
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              flexDirection={"column"}
              rowGap={3}
              padding={2}
            >
              <Avatar sx={{ width: 250, height: 250 }} src={image}>
                {
                  <Button
                    component="label"
                    role={undefined}
                    variant="outlined"
                    tabIndex={-1}
                    sx={{ borderRadius: 4 }}
                  >
                    Upload Logo
                    <VisuallyHiddenInput
                      type="file"
                      onChange={(event) => {
                        const file = event.target.files[0];
                        if (file) {
                          const reader = new FileReader();
                          reader.onloadend = () => {
                            setImage(reader.result);
                          };
                          reader.readAsDataURL(file);
                        }
                      }}
                      multiple={false}
                    />
                  </Button>
                }
              </Avatar>
            </Box>
            <Divider flexItem orientation="vertical" />
            <Stack>
              <FormControl>
                <FormLabel id="subscription-radio-buttons-group-label">
                  Plans
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="subscription-radio-buttons-group-label"
                  name="subscription-radio-buttons-group"
                  value={subscription}
                  onChange={(e) => setSubscription(e.target.value)}
                >
                  {plans.length > 0
                    ? plans.map((plan) => {
                        return (
                          <FormControlLabel
                            key={plan.id}
                            value={plan.id}
                            control={<Radio />}
                            label={plan.plan_name}
                          />
                        );
                      })
                    : null}
                </RadioGroup>
              </FormControl>
              <Typography
                ml={3}
                my={1}
                variant="h5"
                sx={{ fontWeight: "bold" }}
              >
                Ksh {amount()}
              </Typography>

              <form onSubmit={myFormik.handleSubmit} enctype="multipart/form-data">
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  flexDirection={"column"}
                >
                  <Box my={1} display={"flex"} flexDirection={"column"}>
                    <Stack>
                      <TextField
                        size="small"
                        required
                        label="Phone Number"
                        id="primaryPhone"
                        name="primaryPhone"
                        value={myFormik.values.primaryPhone}
                        onChange={myFormik.handleChange}
                        onBlur={myFormik.handleBlur}
                      />
                      {myFormik.errors.primaryPhone &&
                      myFormik.touched.primaryPhone ? (
                        <Typography color="error">
                          {myFormik.errors.primaryPhone}
                        </Typography>
                      ) : null}
                    </Stack>
                  </Box>

                  <Box
                    display={"flex"}
                    mt={2}
                    flexDirection={{ xs: "column", sm: "column", md: "row" }}
                  >
                    <LoadingButton
                      variant="contained"
                      loading={loading}
                      type="submit"
                      disabled={disabled}
                      sx={{ ml: "auto", borderRadius: 5 }}
                      endIcon={<Receipt />}
                    >
                      Make Payment
                    </LoadingButton>
                    <Button onClick={()=>setOpenConfirm(true)}>Already paid</Button>
                  </Box>
                </Box>
              </form>

              <Collapse in={openConfirm} timeout="auto" unmountOnExit>
                <form onSubmit={payForm.handleSubmit}>
                  <Stack mt={1}>
                    <Stack>
                      <TextField
                        size="small"
                        required
                        label="Payment Code"
                        id="code"
                        name="code"
                        value={payForm.values.code}
                        onChange={payForm.handleChange}
                        onBlur={payForm.handleBlur}
                      />
                      {payForm.errors.code && payForm.touched.code ? (
                        <Typography color="error">
                          {payForm.errors.code}
                        </Typography>
                      ) : null}
                    </Stack>
                    <LoadingButton
                      variant="contained"
                      loading={submitLoading}
                      type="submit"
                      sx={{ borderRadius: 5, mt: 1 }}
                    >
                      Confirm
                    </LoadingButton>
                    {paymentError ? (
                        <Typography color="error">
                          {paymentError}
                        </Typography>
                      ) : null}
                  </Stack>
                </form>
              </Collapse>
            </Stack>
          </CardContent>
        </Card>
        </Stack>
      </Zoom>
    </>
  );
}

export default CompanyReg;
